import { FormikProps } from 'formik';
import Checkbox from '../../../components/formInputs/Checkbox';
import useModelSelectOptions from '../../../hooks/useModelSelectOptions';
import { useTranslation } from 'react-i18next';
import FieldWrapper from '../../../components/formInputs/FieldWrapper';
import { TOptions } from '../../../types/types';
import { useEffect, useRef } from 'react';
import CheckboxesSkeleton from '../../../components/loaders/CheckboxesSkeleton';
import { modelsSelectProps } from '../../../utils/selectOptionsProps';

export default function CreateWarrantyFormModels({ formik, makeObj }: { formik: FormikProps<any>; makeObj: TOptions | undefined }) {
  const { t, i18n } = useTranslation();

  const latestFormikRef = useRef(formik);
  const latestModelOptionsRef = useRef<any[]>([]);

  const { modelOptions, apiDataLoading } = useModelSelectOptions(modelsSelectProps(makeObj?.value as number));

  useEffect(() => {
    latestFormikRef.current = formik;
  }, [formik]);

  useEffect(() => {
    latestModelOptionsRef.current = modelOptions || [];
  }, [modelOptions]);

  useEffect(() => {
    return () => {
      const currentFormik = latestFormikRef.current;
      const currentModelOptions = latestModelOptionsRef.current;

      currentFormik.setFieldValue(
        `vehicle_models`,
        currentFormik?.values?.vehicle_models?.filter(
          (model: { vehicle_model_id: number; price: number }) => !currentModelOptions?.some((item: any) => item?.value == model?.vehicle_model_id)
        )
      );
    };
  }, []);

  return (
    <FieldWrapper title={`${makeObj?.label} ${t('models')}`}>
      {apiDataLoading ? (
        <CheckboxesSkeleton columns={4} rows={3} withoutTitles />
      ) : (
        <div className="checkboxes_wrapper row warranty">
          {modelOptions?.map((item: any, i: number) => {
            const selectedModels = formik?.values?.vehicle_models || [];
            const isActive = selectedModels.some((i: any) => i.vehicle_model_id === item?.value);
            return (
              <div className='flex'>
                <Checkbox
                  name={`vehicle_models`}
                  key={i}
                  item={item}
                  value={selectedModels?.some((checkedItem: { vehicle_model_id: number; price: number }) => checkedItem?.vehicle_model_id == item?.value)}
                  checked={selectedModels}
                  formik={formik}
                  customChange={(item) => {
                    if (selectedModels?.some((i: any) => i.vehicle_model_id === item?.value)) {
                      formik?.setFieldValue(
                        `vehicle_models`,
                        selectedModels?.filter((i: any) => i.vehicle_model_id !== item?.value)
                      );
                    } else {
                      formik?.setFieldValue(`vehicle_models`, [...selectedModels, { vehicle_model_id: item.value, price: '' }]);
                    }
                  }}
                  customClass=''
                />
                <div className="inputs_group">
                  <FieldWrapper
                    showUnit
                    unit="SAR"
                    title={t('price')}
                    inputName={`vehicle_models.${selectedModels?.findIndex((ele: any) => ele.vehicle_model_id === item?.value)}.price`}
                    input
                    type="number"
                    disabled={!isActive}
                    noPadding
                  />
                  <FieldWrapper />
                </div>
              </div>
            );
          })}
        </div>
      )}
    </FieldWrapper>
  );
}
